import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import AccountLaneUpdate from '../AccountLaneUpdate'
import AccountLaneCopy from '../AccountLaneCopy'

export default ({
    id,
}: { id: number }) => {
    const {
        Lanes: LanesRoutes,
    } = useAccountManagementRoutes()

    return useSkyNetRoutes({
        routes: [
            {
                path: CommonRoutes.Slash,
                element: <AccountLaneUpdate
                    id={id}
                    disabled
                />,
            },
            {
                path: LanesRoutes.Copy.stringParams,
                element: <AccountLaneCopy id={id} />,
            },
        ],
    })
}
